import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolAddSITypeComponent } from "./school-add-sitype/school-add-sitype.component";
import { SchoolEditSITypeComponent } from "./school-edit-sitype/school-edit-sitype.component";
import { DataService_SchoolIncidentTypeSetup } from "./shared/data.service";

@Component({
	selector: "app-school-incident-type-setup",
	templateUrl: "./school-incident-type-setup.component.html",
	styleUrls: ["./school-incident-type-setup.component.css"],
})
export class SchoolIncidentTypeSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private SchoolIncidentTypeSetupService: DataService_SchoolIncidentTypeSetup,
		private dialogService: DialogService,
		private SchoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchools();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	SchoolID: any;
	lstSchool: any = [];

	ToggleText: any = "Deactivate Type";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchoolIncidentType: any;
	lstSchoolIncidentType: any = [];

	//Filter lists
	lstDefinedByDesc: any = [];
	lstActiveDesc: any = [];
	lstUsedByDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolIncidentTypeDesc", header: "Description" },
		{ field: "SchoolIncidentTypeCD", header: "Code" },
		// { field: 'DefinedByDesc', header: 'Defined By' },
		// { field: 'ActiveDesc', header: 'Active' },
		// { field: 'UsedByDesc', header: 'Used By' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchools() {
		var result = this.SchoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadSchoolIncidentType();
			},
			(error) => {}
		);
	}

	loadSchoolIncidentType() {
		this.loading = true;

		var result = this.SchoolIncidentTypeSetupService.LoadSchoolIncidentType(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSchoolIncidentType = response;

				//Load Data Filter Lists
				this.lstDefinedByDesc = Array.from(new Set(this.lstSchoolIncidentType.map((item: any) => item.DefinedByDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstSchoolIncidentType.map((item: any) => item.ActiveDesc))).sort();
				this.lstUsedByDesc = Array.from(new Set(this.lstSchoolIncidentType.map((item: any) => item.UsedByDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadSchoolIncidentType();
	}

	//Custom Button Methods
	onAddType() {
		this.errorMessage = "";

		if (this.user.UserLevelID == 1) {
			var SchoolName: string = "";
			for (var i = 0; i < this.lstSchool.length; i++) {
				var next = this.lstSchool[i];

				if (next.SchoolID == this.SchoolID) {
					SchoolName = String(next.SchoolName);
				}
			}

			let InfoMsg = "Do you want to add an incident type for the whole disrict or just for " + SchoolName + "?";
			let DistMsg = "Add for District";
			let SchoolMsg = "Add for School";

			this.confirmationService.confirm({
				key: "main",
				acceptLabel: DistMsg,
				acceptIcon: "pi",
				rejectLabel: SchoolMsg,
				rejectIcon: "pi",
				rejectVisible: true,
				message: InfoMsg,
				header: "Add for School or District",
				icon: "fa",
				accept: () => {
					this.CompleteAdd(0);
				},
				reject: () => {
					this.CompleteAdd(this.SchoolID);
				},
			});
		} else {
			this.CompleteAdd(this.SchoolID);
		}
	}

	CompleteAdd(SchoolID) {
		let HeaderMsg = SchoolID > 0 ? "Add Type For School" : "Add Type For District";

		var ref = this.dialogService.open(SchoolAddSITypeComponent, {
			header: HeaderMsg,
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: SchoolID,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchoolIncidentType();
			}
		});
	}

	onEditType() {
		this.errorMessage = "";

		if (this.SelectedSchoolIncidentType == undefined) {
			this.errorMessage = "Select a School Incident Type to Edit";
			return;
		}

		if (this.SelectedSchoolIncidentType.DefinedByID <= 2) {
			this.errorMessage = "System-defined and import-defined School Incident Types can't be edited";
			return;
		} else if (this.user.UserLevelID == 3 && this.SelectedSchoolIncidentType.SchoolID == 0) {
			this.errorMessage = "School users can only edit school level Incident Types";
			return;
		}

		var ref = this.dialogService.open(SchoolEditSITypeComponent, {
			header: "Edit Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedType: this.SelectedSchoolIncidentType,
				SchoolID: this.SchoolID,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchoolIncidentType();
			}
		});
	}

	onDeleteType() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedSchoolIncidentType == undefined) {
			this.errorMessage = "Select a School Incident Type to Delete";
			return;
		}

		if (this.SelectedSchoolIncidentType.DefinedByID <= 2) {
			this.errorMessage = "System-defined and import-defined School Incident Types cannot be deleted";
			return;
		} else if (this.user.UserLevelID == 3 && this.SelectedSchoolIncidentType.SchoolID == 0) {
			this.errorMessage = "School users can only delete school level Incident Types";
			return;
		}

		//Call SP
		var result = this.SchoolIncidentTypeSetupService.DeleteType(this.SelectedSchoolIncidentType.SchoolIncidentTypeID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadSchoolIncidentType();
					this.onRowUnselect(null);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Delete the School Incident Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onToggleType() {
		this.errorMessage = "";
		this.errorMessage = "";

		//Error handling
		if (this.SelectedSchoolIncidentType == undefined) {
			this.errorMessage = "Select a School Incident Type to Toggle";
			return;
		}

		if (this.user.userID != 0 && this.SelectedSchoolIncidentType.DefinedByID <= 2) {
			this.errorMessage = "Only SU can toggle System-defined and import-defined School Incident Types";
			return;
		} else if (this.user.UserLevelID == 3 && this.SelectedSchoolIncidentType.SchoolID == 0) {
			this.errorMessage = "School users can only toggle school level Incident Types";
			return;
		}

		var ChangeTo: any = this.SelectedSchoolIncidentType.ActiveDesc == "Active" ? 0 : 1;

		//Call SP
		var result = this.SchoolIncidentTypeSetupService.ToggleType(this.SelectedSchoolIncidentType.SchoolIncidentTypeID, ChangeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadSchoolIncidentType();
					this.onRowUnselect(null);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Toggle the School Incident Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;

		this.loadSchoolIncidentType();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSchoolIncidentType = val.data;

		this.ToggleText = "Deactivate Type";
		if (this.SelectedSchoolIncidentType.ActiveDesc == "Inactive") {
			this.ToggleText = "Activate Type";
		}
	}
	onRowUnselect(val) {
		this.SelectedSchoolIncidentType = null;

		this.ToggleText = "Deactivate Type";
	}
	onRowDblClick(SchoolIncidentType) {
		this.SelectedSchoolIncidentType = SchoolIncidentType;
		this.onEditType();
	}
	////////////////////////////////////////////
}
